import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=b325f218&scoped=true"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=b325f218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b325f218",
  null
  
)

export default component.exports